export default {"src":"/_next/static/media/plane_24.d3ada2ab.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};